import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { CSSProperties, FC } from 'react';

type EdrTruncatedTextProps = {
  value: string;
  style?: CSSProperties;
  maxWidth?: number | string;
};

/** Single-line table cell text with tooltip for overflow (EDR list tables). */
export const EdrTruncatedText: FC<EdrTruncatedTextProps> = ({
  value,
  style,
  maxWidth = '100%',
}) => {
  const text = value?.trim() || '—';
  return (
    <Tooltip title={text !== '—' ? text : ''} placement="top" enterDelay={300}>
      <Typography noWrap style={{ fontSize: 12, maxWidth, ...style }}>
        {text}
      </Typography>
    </Tooltip>
  );
};
